// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1p-Bv","textarea":"styles_textarea__1mOqa"};